// extracted by mini-css-extract-plugin
module.exports = {"container":"split-loader-with-message_container__8lnMO","message":"split-loader-with-message_message__l7N_L"};